/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import DiscussionListState, { type DiscussionListParams } from 'flarum/forum/states/DiscussionListState';
import type LiteraryWork from 'flarum/orell-articles/models/LiteraryWork';
import type { ReviewListRequestParams } from '../types';

export default class LiteraryReviewsListState extends DiscussionListState {
	work: LiteraryWork;

	constructor(params: DiscussionListParams = {}, page: number, work: LiteraryWork) {
		super(params, page);
		this.work = work;
	}

	requestParams(): ReviewListRequestParams {
		const params = super.requestParams() as ReviewListRequestParams;

		delete params.filter['-isReview'];
		params.filter['literaryWork'] = this.work.id();
		return params;
	}

	sortMap(): Record<string, string> {
		const map = super.sortMap();
		delete map.front;
		return map;
	}
}
